var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2199 21.6301C13.0399 21.6301 11.3699 20.8001 10.0499 16.8301L9.32988 14.6701L7.16988 13.9501C3.20988 12.6301 2.37988 10.9601 2.37988 9.78007C2.37988 8.61007 3.20988 6.93007 7.16988 5.60007L15.6599 2.77007C17.7799 2.06007 19.5499 2.27007 20.6399 3.35007C21.7299 4.43007 21.9399 6.21007 21.2299 8.33007L18.3999 16.8201C17.0699 20.8001 15.3999 21.6301 14.2199 21.6301ZM7.63988 7.03007C4.85988 7.96007 3.86988 9.06007 3.86988 9.78007C3.86988 10.5001 4.85988 11.6001 7.63988 12.5201L10.1599 13.3601C10.3799 13.4301 10.5599 13.6101 10.6299 13.8301L11.4699 16.3501C12.3899 19.1301 13.4999 20.1201 14.2199 20.1201C14.9399 20.1201 16.0399 19.1301 16.9699 16.3501L19.7999 7.86007C20.3099 6.32007 20.2199 5.06007 19.5699 4.41007C18.9199 3.76007 17.6599 3.68007 16.1299 4.19007L7.63988 7.03007Z",
    fill: "url(#paint0_linear_73_96)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.11 14.4C9.92005 14.4 9.73005 14.33 9.58005 14.18C9.29005 13.89 9.29005 13.41 9.58005 13.12L13.16 9.53C13.45 9.24 13.93 9.24 14.22 9.53C14.51 9.82 14.51 10.3 14.22 10.59L10.64 14.18C10.5 14.33 10.3 14.4 10.11 14.4Z",
    fill: "url(#paint1_linear_73_96)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_73_96",
    x1: -5.31195,
    y1: 8.18898,
    x2: 21.9952,
    y2: 20.7914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C040FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B3CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_73_96",
    x1: 7.3361,
    y1: 10.8521,
    x2: 14.5351,
    y2: 14.1682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C040FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B3CFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.8a64f3af2862acda315f85906ef2fe08.svg";
export { ForwardRef as ReactComponent };